import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import paymentComponent from "../../components/DefaultPaymentComponent.vue";
import { IntegrationModule } from "../types";
import { createRejectError, makePurchase, PAYMENT_ERROR_MESSAGES, TIMEOUT_TO_CLOSE } from "../utils";

interface PaymentData {
  purchaseSubject?: Subject<PurchaseSubjectTypeEnum>;
}
const integrationModule: IntegrationModule<PaymentData> = {
  paymentComponent,
  purchase: (data, paymentDetails) =>
    new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeDepositPurchase(t => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve({
            status: true,
            subjectPurchased: !!paymentDetails?.purchaseSubject,
            transaction: t,
          });
        });
        try {
          await makePurchase(() =>
            providers.CCBillFlexFormPurchaseProvider.getDepositUrl({
              data: { subject: paymentDetails?.purchaseSubject, ...data },
            })
          ).catch(e => {
            if (e.message === PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION) {
              timeout = setTimeout(() => {
                subscription.unsubscribe();
                reject(createRejectError(e));
              }, TIMEOUT_TO_CLOSE);
            } else throw e;
          });
        } catch (e) {
          subscription.unsubscribe();
          reject(createRejectError(e));
        }
      } catch (e) {
        reject(createRejectError(e));
      }
    }),
  subscribe: data =>
    new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeRecurringPurchase(s => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve({
            status: true,
            subjectPurchased: false,
            subscription: s,
          });
        });
        try {
          await makePurchase(() => providers.CCBillFlexFormPurchaseProvider.getRecurringUrl({ data })).catch(e => {
            if (e.message === PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION) {
              timeout = setTimeout(() => {
                subscription.unsubscribe();
                reject(createRejectError(e));
              }, TIMEOUT_TO_CLOSE);
            } else throw e;
          });
        } catch (e) {
          subscription.unsubscribe();
          reject(createRejectError(e));
        }
      } catch (e) {
        reject(createRejectError(e));
      }
    }),
  allowSaveCard: false,
  name: $t("CCBillFlexForm"),
  logo: "/img/paymentSystems/ccbill.svg",
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "ccbill-flexform" ?? false;
};

export default integrationModule;
